import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  Agreements = 'agreements',
}

export const queryKeys = {
  AutoAccountAgreement: (clientId: string) => [
    QueryFeature.AutomatedAccount,
    QueryKey.Agreements,
    clientId,
  ],
};
